var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1071_2753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 5.33301H3.16732V6.66634H1.83398V5.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 6.66634H21.1667C21.3435 6.66634 21.513 6.5961 21.6381 6.47108C21.7631 6.34605 21.8333 6.17649 21.8333 5.99967C21.8333 5.82286 21.7631 5.65329 21.6381 5.52827C21.513 5.40325 21.3435 5.33301 21.1667 5.33301H5.16667C4.98986 5.33301 4.82029 5.40325 4.69526 5.52827C4.57024 5.65329 4.5 5.82286 4.5 5.99967C4.5 6.17649 4.57024 6.34605 4.69526 6.47108C4.82029 6.5961 4.98986 6.66634 5.16667 6.66634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 9.33301H3.16732V10.6663H1.83398V9.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 9.33301H5.16667C4.98986 9.33301 4.82029 9.40325 4.69526 9.52827C4.57024 9.65329 4.5 9.82286 4.5 9.99967C4.5 10.1765 4.57024 10.3461 4.69526 10.4711C4.82029 10.5961 4.98986 10.6663 5.16667 10.6663H21.1667C21.3435 10.6663 21.513 10.5961 21.6381 10.4711C21.7631 10.3461 21.8333 10.1765 21.8333 9.99967C21.8333 9.82286 21.7631 9.65329 21.6381 9.52827C21.513 9.40325 21.3435 9.33301 21.1667 9.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 13.333H3.16732V14.6663H1.83398V13.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 13.333H5.16667C4.98986 13.333 4.82029 13.4032 4.69526 13.5283C4.57024 13.6533 4.5 13.8229 4.5 13.9997C4.5 14.1765 4.57024 14.3461 4.69526 14.4711C4.82029 14.5961 4.98986 14.6663 5.16667 14.6663H21.1667C21.3435 14.6663 21.513 14.5961 21.6381 14.4711C21.7631 14.3461 21.8333 14.1765 21.8333 13.9997C21.8333 13.8229 21.7631 13.6533 21.6381 13.5283C21.513 13.4032 21.3435 13.333 21.1667 13.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 17.333H3.16732V18.6663H1.83398V17.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 17.333H5.16667C4.98986 17.333 4.82029 17.4032 4.69526 17.5283C4.57024 17.6533 4.5 17.8229 4.5 17.9997C4.5 18.1765 4.57024 18.3461 4.69526 18.4711C4.82029 18.5961 4.98986 18.6663 5.16667 18.6663H21.1667C21.3435 18.6663 21.513 18.5961 21.6381 18.4711C21.7631 18.3461 21.8333 18.1765 21.8333 17.9997C21.8333 17.8229 21.7631 17.6533 21.6381 17.5283C21.513 17.4032 21.3435 17.333 21.1667 17.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1071_2753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesIcon);
export default __webpack_public_path__ + "static/media/lines-icon.d469c02cb8c09bb3aa889d0305a30743.svg";
export { ForwardRef as ReactComponent };